import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { appLanguageSelector } from '../../../redux/app/selectors'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { driverFormulasSelector } from '../selectors/selectors'
import { useFormulaOptions } from './useFormulaOptions'

export const useCtxDrivers = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const lng = useSelector(appLanguageSelector)
  const options = useFormulaOptions({ companyId, lng, select: driverFormulasSelector })
  return useQuery(options)
}
